import * as React from 'react';
import { Table } from 'semantic-ui-react';

interface ICleanTableProps {
    children
}

export const CleanTable: React.FunctionComponent<ICleanTableProps> = (props) => {
    return <Table>
        {props.children}
    </Table>;

    // return <table className="clean">
    //     {props.children}
    // </table>;
};

